<template>
    <a-input @change="change" :defaultValue="defaultValue" class="input-class" :max-length="maxLength" v-model="item[itemKey]"   :placeholder="placeholder" />
</template>
<script>
export default {
    data(){
        return {}
    },
    props:{
        item:{
            type:Object,
            default:()=>({})
        },
        maxLength:{
            type:Number,
            default:100000
        },
        // 键名
        itemKey:{
            type:String,
            default:''
        },
        placeholder:{
            type:String,
            default:'请输入' 
        },
        type:{
            type:String,
            default:'string',//string,number
        },
        defaultValue:{
            type:[String,Number],
            default:''
        },
        scope:{
            type:Object,
            default:()=>({})
        }
    },
    watch:{
        scope:{
            handler(){
                // console.log(this.scope,'9999scope')
            }
        }
    },
    methods:{
        change(e){
            if(this.type === 'number'){
                this.$emit('inputChange',e,this.item[this.itemKey],this.itemKey)
            }
        }
    }
    
}
</script>